import { Typeahead } from '@/app/components/Typeahead';
import { ArrowRightIcon } from '@heroicons/react/24/solid';
import { useRouter } from 'next/navigation';
import { useState, type JSX } from 'react';
import { useMyPropertiesSearchName } from './useAccountPropertiesSearch';

export interface PropertySearchEntry {
  name: string;
  address: string;
  propertyId: string;
}

export const HeaderSearch = () => {
  const router = useRouter();

  const [search, setSearch] = useState('');
  const { data: propertyData, isLoading } = useMyPropertiesSearchName({
    pagination: {
      currentPage: 1,
      itemsPerPage: 20,
    },
    search: search,
  });

  const onSearchChange = (value: string) => {
    setSearch(value);
  };

  const onPropertyClick = (propertyId: string | undefined) => {
    if (!propertyId) return;

    setSearch('');
    router.push(`/property/${propertyId}/overview`);
  };

  const showStringSearch = (value: string, search: string): JSX.Element => {
    try {
      const searchRegExp = new RegExp(search, 'i');
      const matchedSearch = value.match(searchRegExp);
      if (!matchedSearch) {
        return <p>{value}</p>;
      }

      const [beforeSearchStr, afterSearchStr] = value.split(searchRegExp, 2);
      return (
        <p>
          {beforeSearchStr}
          <span className="text-fiona-blue">{matchedSearch[0]}</span>
          {afterSearchStr}
        </p>
      );
    } catch (error) {
      return <p>{value}</p>;
    }
  };

  const renderProperty = (config: any): React.ReactElement<any> => {
    const propertyData = config.accountProperty;
    return (
      <>
        <div
          key={propertyData.id}
          onClick={() => onPropertyClick(propertyData.id)}
          className="flex min-h-[58px] justify-between overflow-hidden rounded-lg bg-gray-50 px-3 py-2 text-sm text-gray-500 hover:cursor-pointer"
        >
          <div className="flex w-11/12 flex-col gap-1">
            {showStringSearch(propertyData.name || '', search)}
            <span className="truncate">{showStringSearch(propertyData.address1, search)}</span>
            <span>{propertyData?.accountPropertyManagementCompany?.name}</span>
          </div>
          <div className="flex items-center">
            <ArrowRightIcon className="h-3.5 w-3.5" />
          </div>
        </div>
      </>
    );
  };

  return (
    <>
      <Typeahead
        onSearch={onSearchChange}
        value={search}
        data={propertyData?.data || []}
        render={renderProperty}
        placeholder="Search for property..."
        isLoading={isLoading}
        onSelectionChange={(selected: PropertySearchEntry | null) => {
          if (selected) {
            onPropertyClick(selected.propertyId);
          }
        }}
      />
    </>
  );
};
